module.exports = __webpack_public_path__ + "media/images/emlurb_logo-871ba6df.png";